/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-openairway',['require','underscore','jquery','screens/scenario-mapper/scenario','activities/scenario-activity','activities/airway-slider'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var Slider = require('activities/airway-slider');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityOpenAirway = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    attempt: 0,
    maxAttempts: 2,
    scoreValue: 4,

    handPanel: null,
    slider: null,
    doneBtn: null,

    directionsPanel: null,
    tiltObject: null,

    dragItems: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);

      this.performance = 'good';

      this.attempt = 0;
      this.maxAttempts = 2;
      this.scoreValue = 4;

      //this.activityReady();
    },

    begin: function()
    {
      ScenarioActivity.prototype.begin.apply(this, arguments);
      //var self = this;
      //console.warn('show', this.get('#animation-sprite img'));

      //this.playAudio();
      this.playAudio('audio', this.content, this.loadCurrentPhase);
      /*//console.log(this.get('#animation-sprite'));
      this.get('#animation-sprite').sprite({
        'fps': 1,
        'no_of_frames': 2,
        'play_frames': 4,
        //'on_last_frame': self.finish.bind(self)
      });
      //console.log('showing now it should play');
      setTimeout(function() {self.get('#animation-sprite').spStart(true);}, 1000);*/
    },

    onBeforeDestroy: function()
    {

      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
    },

    finish: function()
    {
      this.performance = 'average';

      if (this.scoreValue === 4)
        this.performance = ScenarioActivity.PERFORMANCE_GOOD;
      else if (this.scoreValue <= 1)
        this.performance = 'poor';

      // make sure head is in correct position before recording variable
      //this.moveHeadToCorrectPosition(false);

      this.doneBtn.off('click');
      this.doneBtn.addClass('disabled');

      // set head rotation scenario variable
      var $head = this.get('[data-mc=head]');// || this.mc.head.getChildAt(0);
      if ($head)
      {
        var $rotation = $head.getRotateAngle().toString();
        //console.log('rotation: ' + $rotation);
        Scenario.setVariable('openAirway_rotation', $rotation);
      }

      var self = this;
      _.delay(function() {
        ScenarioActivity.prototype.finish.apply(self);
      }, 100);
    },

    setupPlaceHands: function()
    {
      this.playAudio('audio', this.currentPhase);

      this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });

      /*this.handPanel.find('.airway-hand').draggable({
        containment: '[data-role=scenario-activity]',
        cursor: 'move',
        scroll: false,
        //start: $.proxy(this.onStartDrag, this),
        revert: $.proxy(this.onIncorrectDrop, null, this),
        //revert: 'invalid'
      });*/
      this.dragItems = Draggable.create(this.handPanel.find('.airway-hand'), {
        bounds: '[data-role=scenario-activity]',
        onPress: this.onStartDrag,
        onPressParams: [this],
        onDragEnd: this.onEndDrag,
        onDragEndParams: [this],
        //force3D: false,
        type: 'top, left'
      });

      //var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');

      /*_.each(this.dropPanel.find('.activity-drop'), function(dropDiv) {
        var $dropItem = $(dropDiv);
        var $validAccept = (self.currentPhase['universal']) ? '.activity-drag' : '[data-mc=' + $dropItem.attr('data-mc').replace('drop', 'item') + ']';

        $dropItem.droppable({
          accept: $validAccept,
          hoverClass: 'over',
          greedy: true,
          drop: $.proxy(self.onCorrectDrop, self, $dropItem)
        });
      });*/
      //this.handPanel.setup( { onDragStop: this.onCorrectDrop } );
    },

    onStartDrag: function(self)
    {
      //console.log('start', this, this.target);
      //$(this.target).data().origin = $(this.target).position();
    },

    onEndDrag: function(self)
    {
      var $drag = $(this.target);
      var $cDrop = (self.currentPhase['universal']) ? self.currentScene.find('.activity-drop:not(.is-correct)') : self.currentScene.find('[data-mc=' + $drag.attr('data-mc').replace('item', 'drop') + ']');
      //console.log('end', $drag, $cDrop, self.currentPhase['universal']);

      var $hits = _.some($cDrop, function(dropEl) {
        var $drop = $(dropEl);
        if (Draggable.hitTest($drag, $drop, '70%'))
        {
          $cDrop = $drop;
          return true;
        }
        return false;
      }, this);

      //console.log('hit: ' + $hits);

      if ($drag.data().origin && Math.abs($drag.data().origin.left - $drag.position().left) <= 150) // still in drop pen
      {
        //console.log('bin');
        self.revertDrag($drag);
      }
      else if ($cDrop.length > 0 && $hits)//Draggable.hitTest($drag, $cDrop, '70%')) // correct
      {
        //console.log('correct');
        self.onCorrectDrop.apply(self, [$cDrop, $drag]);
      }
      else // incorrect
      {
        //console.log('incorrect');
        self.onIncorrectDrop(self, $drag);
      }
      //self.onIncorrectDrop.apply($(this.target), self, true);
      //self.onIncorrectDrop($(this.target), true);
    },

    revertDrag: function(drag)
    {
      //TweenLite.to(drag, 0.5, {transform: 'translate3d(' + drag.data().origin.left + ', ' + drag.data().origin.top + ', 0)'});
      TweenLite.to(drag, 0.5, {left: drag.data().origin.left, top: drag.data().origin.top});
    },

    setupTiltHead: function()
    {
      this.attempt = 0;

      this.tiltObject = _.findWhere(this.currentPhase.ContentObject, {'id': 'tilt-range'});//.getByName('tilt-range');

      this.tiltObject.maxRotation = (this.tiltObject.maxRotation === undefined) ? '-45' : this.tiltObject.maxRotation;

      this.playAudio('audio', this.currentPhase);

      this.slider = new Slider(this.get('[data-mc=sliderHolder]'));
      this.slider.setup({onSliderUpdate: $.proxy(this.onSliderUpdate, this)});

      //this.mc.head.stop();

      //this.doneBtn = new Button(this.mc.doneHolder.done);
      //this.doneBtn.setup({onMouseClick: this.onDoneClick});
      this.doneBtn = this.get('[data-mc=doneHolder] [data-mc=done]');
      this.doneBtn.one('click', $.proxy(this.onDoneClick, this));

      if (this.currentPhase.hideLines)// && this.mc.lines)
        this.get('[data-mc=lines]').hide();//.visible = false;
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      ////console.log('on up ', $dropItem, $e, $drag.draggable);
      //var $correct = false;
      //var $drop;
      //var $point;
      //var $coords;
      //var $dragPoint;
      //var $dragCoords;
      Draggable.get($drag).disable();
      $drag.addClass('is-correct');
      $dropItem.addClass('is-correct');
      //$drag.draggable.draggable('disable');

      if (this.get('.correctDragHolder').length > 0)
      {
        this.get('.correctDragHolder').append($drag);
      }
      if (this.allComplete())
      {
        this.phaseIndex++;
        this.playAudio('audio-feedback-correct', this.phases[this.phaseIndex - 1], this.loadCurrentPhase);
      }

      $drag.offset($dropItem.offset());//($coords, {time: 0.25, transition: 'easeoutquad'}, false);
      return false;
    },

    onIncorrectDrop: function($scope, $drag)
    {
      $scope.scoreValue--;
      $scope.attempt++;
      if ($scope.attempt >= $scope.maxAttempts)
      {

        $scope.phaseIndex++;
        $scope.moveHandsToCorrectSpots($drag);
        $scope.playAudio('audio-feedback-incorrect-final', $scope.phases[$scope.phaseIndex - 1], $scope.loadCurrentPhase);
        //return true;
        return;
      }
      else
      {
        $scope.revertDrag($drag);
        //$drag.returnToOrigin({time: 0.25, transition: 'easeoutquad'});
      }
      $scope.playAudio('audio-feedback-incorrect', $scope.currentPhase);
      return true;
    },

    moveHandsToCorrectSpots: function($activeDrag)
    {
      //Draggable.get(this.handPanel.find('.airway-hand')).disable();//.draggable('disable');
      var $sendBack = true;
      var $dragArr = this.handPanel.find('.airway-hand').get();
      for (var $key = 0; $key < this.handPanel.find('.airway-hand').length; $key++)
      {
        var $drag = $($dragArr[$key]);
        Draggable.get($drag).disable();
        var $id = $drag.attr('data-mc').replace('item', 'drop');//NLUtils.getItemNumber($drag.mc);
        var $drop = this.currentScene.find('[data-mc=drop_items]').find('[data-mc=' + $id + ']');

        if ($drop.length > 0)
        {
          if ($drag.attr('data-mc') === $activeDrag.attr('data-mc'))
            $sendBack = false;
          //var $point = {};//new Point($drop.x, $drop.y);
          //var $coords = {};//NLUtils.localToLocal($point, this.mc, this.handPanel.mc);
          ////console.log(this.handPanel.css('padding'), parseInt(this.handPanel.css('padding')));
          //var $adjust = parseInt(this.handPanel.css('padding'));
          var $left = $drop.offset().left - this.handPanel.offset().left;// - $adjust;//.replace('px', '');
          var $top = $drop.offset().top - this.handPanel.offset().top;// - $adjust;//.replace('px', '');

          if (this.get('.correctDragHolder').length > 0)
            this.get('.correctDragHolder').append($drag);
          else
            $drag.css('z-index', ($key + 1) * 2);

          TweenLite.to($drag, 0.5, {left: $left, top: $top});//.animate({left: $left, top: $top}, {duration: 250});
        }
        else
        {
          this.revertDrag($drag);
        }
      }
      return $sendBack;
    },

    allComplete: function()
    {
      //console.log('check all complete');
      //for (var $key in this.handPanel.find('.airway-hand'))
      for (var $key = 0; $key < this.handPanel.find('.airway-hand').length; $key++)
      {
        var $item = $(this.handPanel.find('.airway-hand')[$key]);
        //console.log($item);
        if (!$item.hasClass('is-correct'))
          return false;
      }
      //console.log('yep all complete');
      return true;
    },

    onSliderUpdate: function($e, $slider)
    {
      var $perc = this.slider.value / 100;
      var $head = this.get('[data-mc=head]');
      //console.log('slider update', $perc, $head);
      $head.rotate(parseInt(this.tiltObject.maxRotation) * $perc);//($perc / 100 * this.mc.head.totalFrames);
    },

    onDoneClick: function($e)
    {
      // check correctness
      var $result = this.evaluateTilt();

      if ($result.correct)
      {
        this.slider.disable();
        this.doneBtn.addClass('disabled');

        this.phaseIndex++;

        this.playAudio('audio-feedback-correct', this.phases[this.phaseIndex - 1], $.proxy(this.loadCurrentPhase, this));
      }
      else
      {
        this.scoreValue--;
        this.attempt++;
        if (this.attempt >= this.maxAttempts)
        {
          this.slider.disable();
          this.doneBtn.addClass('disabled');

          this.moveHeadToCorrectPosition();

          this.phaseIndex++;
          this.playAudio('audio-feedback-incorrect-final', this.phases[this.phaseIndex - 1], $.proxy(this.loadCurrentPhase, this));
        }
        else
        {
          // play incorrect feedback
          //var $audio = this.currentPhase.getByID($result.audio);
          var $audio = _.findWhere(this.currentPhase.ContentAudio, {'id': $result.audio});//.getByName('tilt-range');
          //console.log($audio);

          if (!$audio || $audio.length === 0)
            $result.audio = 'audio-feedback-incorrect';

          this.playAudio($result.audio, this.currentPhase);
          this.doneBtn.one('click', $.proxy(this.onDoneClick, this));
        }
      }
    },

    evaluateTilt: function()
    {
      var $result = { };
      $result.correct = true;

      var $tiltObject = this.tiltObject;//this.currentPhase.getByName('tilt-range');
      //this.tiltObject = _.findWhere(this.currentPhase.ContentObject, {'id': 'tilt-range'});//.getByName('tilt-range');

      if ($tiltObject.range.toString().indexOf('-') !== -1)
      {
        var $from = $tiltObject.range.split('-')[0];
        var $to = $tiltObject.range.split('-')[1];
        if (this.slider.value > $to)
        {
          $result.correct = false;
          $result.audio = 'audio-feedback-incorrect-high';
        }
        else if (this.slider.value < $from)
        {
          $result.correct = false;
          $result.audio = 'audio-feedback-incorrect-low';
        }
      }
      else if (!isNaN($tiltObject.range))
      {
        if (this.slider.value !== $tiltObject.range)
        {
          $result.correct = false;
          $result.audio = 'audio-feedback-incorrect';
        }
      }

      return $result;
    },

    moveHeadToCorrectPosition: function($tween)
    {
      $tween = $tween === undefined ? true : $tween;

      if (!this.tiltObject)
        return;

      var $props = { time:1, transition: 'easeoutquad' };
      var $frame = 1;
      //console.warn('move head ', this.tiltObject.range.toString());
      if (this.tiltObject.range.toString().indexOf('-') !== -1)
      {
        var $from = this.tiltObject.range.toString().split('-')[0];
        var $to = this.tiltObject.range.toString().split('-')[1];
        $frame = Math.round((parseInt($from) + parseInt($to)) / 2);
      }
      else if (!isNaN(this.tiltObject.range))
      {
        $frame = parseInt(this.tiltObject.range);
      }

      $props._frame = $frame;

      //Tweener.removeTweens(this.mc.head);
      //console.warn('frame rotation ', $frame);
      // if ($tween)
      //   $frame = '';//Tweener.addTween(this.mc.head, $props);
      // else

      this.slider.value = $frame;
      this.onSliderUpdate();
      //this.get('[data-mc=head]').rotate($frame, 'abs');
    },

    disableDrags: function($drag)
    {
      if ($drag)
      {
        if ($drag.disable)
          $drag.disable();
        else
          Draggable.get($drag).disable();
      }
      else
      {
        var __self = this;
        _.forEach(this.dragItems, function(__drag) {
          __self.disableDrags(__drag);
        });
      }
    },

  /*****************************************************************************************************************///}

  });

  return ActivityOpenAirway;

});

